import {Injectable} from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import {environment} from '../../../environments/environment';

// todo: add types for this
declare let google: any;

@Injectable()
export class MapService {
    lat = 25.266666;
    lng = 55.316666;
    zoom = 12;

    getMap(elem) {
        const region_type = localStorage.getItem('region_type');
        if (region_type === '1') { // Africa house
            this.lat = 0;
            this.lng = 23.7348;
            this.zoom = 4;
        }
        const mapOptions = {
            center: {
                lat: this.lat,
                lng: this.lng
            },
            zoom: this.zoom
        };

        return new Loader({
            apiKey: environment.mapsKey,
            version: 'weekly',
            libraries: ['places', 'geometry']
        }).load().then(google => {
            return new google.maps.Map(elem, mapOptions);
        })
    }
}
